/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 4 hook(s) need dependency review; fix each and remove this directive */
import { getBackendUrl } from "@Utils";
import { useTranslation, untranslated } from "@i18n";
import React, { forwardRef, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { getViewerUrl, formCategories } from "@Helpers";
import { defaultSignatureModalState } from "./ReviewsConstants";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import DeleteIcon from "@Components/StickySidebarViewer/assets/DeleteIcon";
import CreateIcon from "@Components/StickySidebarViewer/assets/CreateIcon";
import OpenFileInViewerIcon from "@Assets/icons/OpenInViewer.svg";
import SlickGrid1 from "@CubeComponents/html/SlickGrid1";
import ResourceActivityInReview from "./ResourceActivityInReview";
import { Box } from "@mui/material";
import { portalCreateRoot } from "@CubeComponents/html/cellPortals";
import { flushSync } from "react-dom";

import {
  addResourcesToReview,
  fileStatusHelper,
  getFilesInReviewToolbar,
  getResourceDetails,
  getReviewData,
  getStatusBtnStyle,
  removeResourcesFromReview,
  updateFilesInReview,
} from "./ReviewsHelper";
import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { fetchListOfStatusesAvailableRequest } from "@Features/reviews/api/reviews.api";
import { getResourcesInReviewUrl } from "@Services/dataManager";
import ToolTipComponent from "@CubeComponents/html/tooltip";
import ChangeFileStatusModal from "./ChangeFileStatusModal";
import FilePropertiesInReviews from "./FilePropertiesInReviews";
import DetailsIcon from "@Components/StickySidebarViewer/assets/Details";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "@Services/constants";
import { showToastNotification } from "@Reducers/toastSlice";
import { FileManagerAsPopup } from "@Features/files";
import { useDispatch, useSelector } from "react-redux";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import ResourceStatusHistoryInReview from "./ResourceStatusHistoryInReview";
import { ReviewUpdateIcon, ReviewFileHistory } from "@Components/StickySidebarViewer/assets/ReviewUpdateIcon";
import AddSignatureToResource from "./AddSignatureToResource";
import IconComponent from "@CubeComponents/icons";
import Attachments from "./AddReferencedFileInReviews";
import ChecklistModal from "./ChecklistModal";
import _ from "lodash";
import {
  doExcelExportActivity,
  processDrawingNumbersAndDocDate,
  processProjectCustomFieldData,
  processReviewDataForAttachedFiles,
} from "./ReviewSheetForFichtner";
import { downloadFile } from "@Services/fileDownload";
import { setTransmittalDataForReviews } from "@Features/transmittals";
import Transmittals from "@Assets/icons/svg/TransmittalIcon.svg";
import axiosWrapper from "@AxiosWrapper";
import type { GetTransmittalDataByIdResponse } from "@ServerTypes/transmittals/transmittals.schema";
import type { GetFormTemplateResponse } from "@ServerTypes/portal/portal.schema";
import CreateTransmittal from "@Features/transmittals/pages/Transmitals/CreateTransmittal/CreateTransmittal";
import ChecklistAssignmentModal from "./ChecklistAssignmentModal";
import Text from "@CubeComponents/html/Text/Text";

interface FilesInReviewProps {
  readonly reviewId: string;
  readonly spaceId: string;
  readonly projectId: string;
  readonly enableBtns: {
    approve: { status: boolean; errorMessage: string };
    skip: { status: boolean; errorMessage: string };
    revoke: { status: boolean; errorMessage: string };
    rollback: { status: boolean; errorMessage: string };
  };
  readonly showProperties?: boolean;
  readonly refreshData: (refreshFiles: boolean, refreshIssues: boolean, refreshReviewData: boolean) => void;
  readonly allowFileAddition?: boolean;
  readonly allowFileUpdate?: boolean;
  readonly allowFileRemoval?: boolean;
  readonly allowBulkTransition?: boolean;
  readonly allowAddSignature?: boolean;
  readonly allowSendTransmittals?: boolean;
}

interface FileActivityModal {
  show: boolean;
}

interface AddFileModal {
  show: boolean;
  data: any;
  stage: number;
}

interface StatusHistoryModal {
  show: boolean;
  statuses?: any[];
  signatures?: any[];
}

interface SignatureModal {
  show: boolean;
  reviewId?: string;
  statusTo?: any;
  statusFrom?: any;
  resources?: any[];
  type?: string;
  requireMandatoryComment?: boolean;
}

interface FileProperties {
  show: boolean;
  data: any;
}

interface RemoveFileModal {
  show: boolean;
  resources: any[];
}

interface BulkTransitionModal {
  show: boolean;
  fileVersionIds?: string[];
  data?: {
    resources: any[];
    statusFrom?: any;
    reviewId?: string;
    type?: string;
    requireMandatoryComment?: boolean;
  };
}

interface UpdateFileConfirmModal {
  show: boolean;
  fileVersionIds: string[];
}

interface AddSignatureToResourceModal {
  show: boolean;
  data: any;
}

interface OpenAttachmentModal {
  show: boolean;
  fileVersionId?: string;
  attachments?: any[];
}

interface ProjectCustomField {
  status: boolean;
  data: any[];
}

interface ChecklistModalState {
  show: boolean;
  fileVersionId: string | null;
  checklists: any[];
}

interface FileSizeOption {
  name: string;
  divideValue: number;
}

interface ProcessedTransmittalRecord {
  fileVersion: string;
  resourceType: string;
  name: string;
  versionNumber: number;
  size: number;
  dateCreated: string | number;
  fileType: string;
}

interface RootState {
  userDetails: any;
  reviewData: any;
  transmittalDataForReviews: any;
  portalData: any;
  projectData: any;
}

const FilesInReview = forwardRef<any, FilesInReviewProps>(
  (
    {
      reviewId,
      spaceId,
      projectId,
      enableBtns,
      showProperties = false,
      refreshData,
      allowFileAddition = true,
      allowFileUpdate = true,
      allowFileRemoval = true,
      allowBulkTransition = false,
      allowAddSignature = false,
      allowSendTransmittals = false,
    },
    ref,
  ) => {
    const { t } = useTranslation();
    const dataGrid = ref as React.RefObject<any>;
    const dispatch = useDispatch();

    const fileSizeOptions: FileSizeOption[] = [
      { name: "KB", divideValue: 1024 },
      { name: "MB", divideValue: 1048576 },
    ];

    const { userDetails, reviewData, transmittalDataForReviews } = useSelector((state: RootState) => ({
      userDetails: state.userDetails,
      reviewData: state.reviewData,
      transmittalDataForReviews: state.transmittalDataForReviews,
    }));

    const [isLoadingComplete, setIsLoadingComplete] = useState<boolean>(false);
    const [fileActivityModal, setFileActivityModal] = useState<FileActivityModal>({ show: false });
    const [addFileModal, setAddFileModal] = useState<AddFileModal>({
      show: false,
      data: null,
      stage: 1,
    });
    const [statusHistoryModal, setStatusHistoryModal] = useState<StatusHistoryModal>({
      show: false,
    });
    const [signatureModal, setSignatureModal] = useState<SignatureModal>(defaultSignatureModalState);
    const [fileProperties, setFileProperties] = useState<FileProperties>({
      show: false,
      data: null,
    });
    const [removeFileModal, setRemoveFileModal] = useState<RemoveFileModal>({
      show: false,
      resources: [],
    });
    const [bulkTransitionModal, setBulkTransitionModal] = useState<BulkTransitionModal>({
      show: false,
      fileVersionIds: [],
    });
    const [updateFileConfirmModal, setUpdateFileConfirmModal] = useState<UpdateFileConfirmModal>({
      show: false,
      fileVersionIds: [],
    });
    const [addSignatureToResourceModal, setAddSignatureToResourceModal] = useState<AddSignatureToResourceModal>({
      show: false,
      data: {},
    });
    const [openAttachmentModal, setOpenAttachmentModal] = useState<OpenAttachmentModal>({
      show: false,
    });
    const [projectCustomField, setProjectCustomField] = useState<ProjectCustomField>({
      status: false,
      data: [],
    });
    const [checklistModal, setChecklistModal] = useState<ChecklistModalState>({
      show: false,
      fileVersionId: null,
      checklists: [],
    });
    const [propertiesBtnDisabled, setPropertiesBtnDisabled] = useState<boolean>(true);
    const [isLoadingFileUpdate, setIsLoadingFileUpdate] = useState<boolean>(false);
    const [isLoadingAddFiles, setIsLoadingAddFiles] = useState<boolean>(false);
    const [isLoadingRemoveFiles, setIsLoadingRemoveFiles] = useState<boolean>(false);
    const [openCreateTransmittalModal, setOpenCreateTransmittalModal] = useState<boolean>(false);
    const [processedTransmittalRecords, setProcessedTransmittalRecords] = useState<ProcessedTransmittalRecord[]>([]);
    const [checklistFlowData, setChecklistFlowData] = useState<any>(null);
    const [statusOptionsCache, setStatusOptionsCache] = useState<Record<string, any[]>>({});

    const { portalData, projectData } = useSelector((state: RootState) => state);

    const reviewDataHelperRef = useRef(reviewData);

    const filesQuery = useMemo(
      () => ({
        params: {
          resourceTypes: ["RESOURCE_TYPE_FILE", "RESOURCE_TYPE_EMBED"],
          reviewId,
        },
      }),
      [reviewId],
    );

    const addBtnTemplate = useCallback(
      () => (
        <div className="me-[1.875rem] bg-transparent">
          <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} id="add_file">
            <span className="flex flex-row items-center justify-start">
              <CreateIcon size="15" className="me-1" />
              <Text>{t("Add")}</Text>
            </span>
          </ButtonComponent>
        </div>
      ),
      [],
    );

    const updateBtnTemplate = useCallback(
      () => (
        <div className="me-[1.875rem] bg-transparent">
          <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="update_file">
            <span className="flex flex-row items-center justify-start">
              {(ReviewUpdateIcon as any)({ size: "15", className: "me-1" })}
              <Text>{t("Update")}</Text>
            </span>
          </ButtonComponent>
        </div>
      ),
      [],
    );

    const removeBtnTemplate = useCallback(
      () => (
        <div className="me-[1.875rem] bg-transparent">
          <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="remove_file">
            <span className="flex flex-row items-center justify-start">
              <DeleteIcon size="15" className="me-1" />
              <Text>{t("Remove")}</Text>
            </span>
          </ButtonComponent>
        </div>
      ),
      [],
    );

    const fileActivityBtnTemplate = useCallback(
      () => (
        <div className="me-[1.875rem] bg-transparent">
          <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="file_activity">
            <span className="flex flex-row items-center justify-start">
              <ReviewFileHistory size="15" className="me-1" {...({} as any)} />
              <Text>{t("Show File History")}</Text>
            </span>
          </ButtonComponent>
        </div>
      ),
      [],
    );

    const bulkTransitionBtnTemplate = useCallback(
      () => (
        <div className="me-[1.875rem] bg-transparent">
          <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="bulk_transition">
            <span className="flex flex-row items-center justify-start">
              <IconComponent name="Sync" width="0.9375rem" height="0.9375rem" className="me-1" />
              <Text>{t("Bulk Transition")}</Text>
            </span>
          </ButtonComponent>
        </div>
      ),
      [],
    );

    const addSignatureToFileBtnTemplate = useCallback(
      () => (
        <div className="me-[1.875rem] bg-transparent">
          <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="add_signature">
            <span className="flex flex-row items-center justify-start">
              <IconComponent name="inPdfSignature" width="0.9375rem" height="0.9375rem" className="me-1" />
              <Text>{t("Add Signature")}</Text>
            </span>
          </ButtonComponent>
        </div>
      ),
      [],
    );

    const excelExportReviews = useCallback(() => {
      if (!enableBtns.approve.status) return null;

      return (
        <div className="me-[1.875rem] bg-transparent">
          <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="excel_export_reviews">
            <span className="flex flex-row items-center justify-start">
              <img src={Transmittals} className="me-2" alt={t("Transmittals")} />
              <Text>{t("Send via Transmittals")}</Text>
            </span>
          </ButtonComponent>
        </div>
      );
    }, [enableBtns.approve.status]);

    const downloadReviewsFiles = useCallback(
      () => (
        <div className="me-[1.875rem] bg-transparent">
          <ButtonComponent buttonType={BUTTON_TYPES.TEXT_BUTTON} id="download_reviews_files">
            <span className="flex flex-row items-center justify-start">
              <IconComponent name="download" width="1.5rem" height="1.5rem" className="me-2" />
              <Text>{t("Download")}</Text>
            </span>
          </ButtonComponent>
        </div>
      ),
      [],
    );

    const processRecordsForTransmittals = () => {
      const selectedRecords = (dataGrid.current?.dataView?.getAllSelectedItems() || []).filter(
        (record: any) => record && !record.__isDummy && record.fileVersionId && record.details,
      );
      const processedRecords: ProcessedTransmittalRecord[] = selectedRecords.map((record: any) => ({
        fileVersion: record.fileVersionId,
        resourceType: record.resourceType,
        name: record.details.name,
        versionNumber: record.details.versionNumber,
        size: record.details.size,
        dateCreated: record.addedDate,
        fileType: record.details.fileType,
      }));
      setProcessedTransmittalRecords(processedRecords);
      return processedRecords.length;
    };

    const toolbar = useMemo(
      () =>
        getFilesInReviewToolbar({
          addBtnTemplate,
          updateBtnTemplate,
          removeBtnTemplate,
          fileActivityBtnTemplate,
          bulkTransitionBtnTemplate,
          addSignatureToFileBtnTemplate,
          excelExportReviews,
          downloadReviewsFiles,
          allowSendTransmittals,
        }),
      [
        allowSendTransmittals,
        addBtnTemplate,
        updateBtnTemplate,
        removeBtnTemplate,
        fileActivityBtnTemplate,
        bulkTransitionBtnTemplate,
        addSignatureToFileBtnTemplate,
        excelExportReviews,
        downloadReviewsFiles,
      ],
    );

    const closeStatusHistory = () => {
      setStatusHistoryModal({ show: false });
    };

    const openStatusHistoryFromData = (rowData: any) => {
      const { statuses, signatures } = rowData;
      if (statuses?.length > 1 || signatures?.length) {
        setStatusHistoryModal({ show: true, statuses, signatures });
      }
    };

    const openFileInViewer = (e: React.MouseEvent<HTMLElement>) => {
      const fileVersionId = (e.currentTarget as HTMLElement).dataset.fileversionid || "";

      const viewerUrl = getViewerUrl({ fileVersionId, spaceId, projectId });
      window.open(viewerUrl, "_blank");
    };

    const closeSignatureModal = (shouldRefreshGrid: boolean = false) => {
      if (shouldRefreshGrid) {
        refreshData(true, false, false);
      }

      setSignatureModal(defaultSignatureModalState);
    };

    const openChecklistModalFromData = (rowData: any) => {
      setChecklistModal({
        show: true,
        fileVersionId: rowData.fileVersionId,
        checklists: rowData.checklists,
      });
    };

    const closeChecklistModal = () => {
      setChecklistModal({ show: false, fileVersionId: null, checklists: [] });
      refreshData(true, true, true);
    };

    const fileStatusChanged = (newValue: any, previousStatus: any, fileVersionId: string, resourceType: string) => {
      const statusTo = newValue;
      const resources = [{ fileVersionId, resourceType }];

      const statusFrom = previousStatus || {
        _id: null,
        name: null,
        category: null,
      };

      const { approvalStages } = reviewDataHelperRef.current;
      const currentStage = approvalStages.find((stage: any) => stage.clearanceStatus === "in_progress");
      const requireMandatoryComment = currentStage
        ? currentStage.requireMandatoryComment.enabled && currentStage.requireMandatoryComment.values.includes(4)
        : false;

      setSignatureModal({
        show: true,
        reviewId,
        statusTo,
        statusFrom,
        resources,
        type: "standardTransition",
        requireMandatoryComment,
      });
    };

    const fetchStatusOptionsForFile = async (fileVersionId: string, resource: string) => {
      if (statusOptionsCache[fileVersionId]) return statusOptionsCache[fileVersionId];
      try {
        const response = await fetchListOfStatusesAvailableRequest({
          value: { params: { reviewId, resource } },
        } as any);
        if (response.data?.result) {
          const statusOptions = response.data.result;
          setStatusOptionsCache((prev) => ({ ...prev, [fileVersionId]: statusOptions }));
          return statusOptions;
        }
      } catch (e) {
        console.error("Error fetching status options:", e);
        Promise.reject(e);
      }
      return [];
    };

    const openFileProperties = (selectedRecord: any) => {
      const { statuses, fileVersionId, resourceType, details } = selectedRecord;
      const { name: fileName, versionNumber: fileVersionNumber, size } = details;
      const fileType = fileName.split(".").slice(-1)[0].toUpperCase();

      setFileProperties({
        show: true,
        data: {
          fileVersionId,
          fileName,
          fileType,
          fileVersionNumber,
          statuses,
          size,
          resourceType,
        },
      });
    };

    const closeFileProperties = () => {
      setFileProperties({ show: false, data: null });
    };

    const closeAddFileModal = () => {
      setAddFileModal({ show: false, data: null, stage: 1 });
    };

    const addFileInReview = () => {
      setAddFileModal({ show: true, data: null, stage: 1 });
    };

    const backToFileSelection = () => {
      setIsLoadingAddFiles(false);
      setAddFileModal((prev) => ({
        ...prev,
        stage: 1,
        data: null,
      }));
    };

    const handleChecklistAssignment = async (updatedData: any) => {
      setIsLoadingAddFiles(true);
      const response = await addResourcesToReview({
        resources: updatedData.resources,
        reviewId,
      });
      setIsLoadingAddFiles(false);
      closeAddFileModal();
      handleToastNotification(response);
    };

    const updateFileVersionInReview = (fileVersionIds: string[]) => {
      setUpdateFileConfirmModal({ show: true, fileVersionIds });
    };

    const closeUpdateFileModal = () => {
      setUpdateFileConfirmModal({ show: false, fileVersionIds: [] });
    };

    const closeRemoveFileModal = () => {
      setRemoveFileModal({ show: false, resources: [] });
    };

    const closeAttachmentModal = () => {
      setOpenAttachmentModal({ show: false });
      closeSignatureModal(true);
    };

    const getResourceDetailsForRemoval = (resources: any[]) =>
      resources.map((resource) => {
        const { resourceType } = resource;

        if (resourceType === "RESOURCE_TYPE_FILE" || resourceType === "RESOURCE_TYPE_EMBED") {
          const { fileVersionId } = resource;
          return { fileVersionId, resourceType };
        }

        if (resourceType === "RESOURCE_TYPE_ESTIMATE") {
          const { estimateId, estimateVersionId } = resource;
          return { estimateId, estimateVersionId, resourceType };
        }

        if (resourceType === "RESOURCE_TYPE_ISSUE") {
          const { issueId } = resource;
          return { issueId, resourceType };
        }

        if (resourceType === "RESOURCE_TYPE_TASKS") {
          const { taskId } = resource;
          return { taskId, resourceType: "RESOURCE_TYPE_TASK" };
        }
      });

    const removeFileFromReview = (selectedRecords: any[]) => {
      const resources = getResourceDetailsForRemoval(selectedRecords);
      setRemoveFileModal({ show: true, resources });
    };

    const openFileActivity = () => {
      setFileActivityModal({ show: true });
    };

    const closeFileActivityModal = () => {
      setFileActivityModal({ show: false });
    };

    const downLoadReviewFiles = (fileVersionIds: string[]) => {
      downloadFile({
        fileVersionIds,
        folderIds: [],
        type: "Download",
      });
    };

    const getStatusFromForResources = (records: any[]) => {
      const statusFromSet = new Set();

      records.map((record) => {
        const currentStatus = record.statuses.slice(-1)[0]._id;
        if (!statusFromSet.has(currentStatus)) {
          statusFromSet.add(currentStatus);
        }
      });

      const statusFromList = Array.from(statusFromSet);

      if (statusFromList?.length > 1) {
        return { _id: "Varies", name: "Varies", category: "Varies" };
      }

      const status = records[0].statuses.slice(-1)[0];
      const { _id, name, category } = status;
      return { _id, name, category };
    };

    const executeBulkTransition = (selectedRecords: any[]) => {
      const { approvalStages } = reviewDataHelperRef.current;
      const currentStage = approvalStages.find((stage: any) => stage.clearanceStatus === "in_progress");
      const requireMandatoryComment = currentStage
        ? currentStage.requireMandatoryComment.enabled && currentStage.requireMandatoryComment.values.includes(4)
        : false;

      const resources = getResourceDetailsForRemoval(selectedRecords);
      const statusFrom = getStatusFromForResources(selectedRecords);
      setBulkTransitionModal({
        show: true,
        data: {
          resources,
          statusFrom,
          reviewId,
          type: "bulkTransition",
          requireMandatoryComment,
        },
      });
    };

    const closeBulkTransitionModal = (shouldRefreshGrid: boolean = false) => {
      if (shouldRefreshGrid) {
        refreshData(true, false, false);
      }

      setBulkTransitionModal({ show: false, data: { resources: [] } });
    };

    const addSignatureToResource = async (selectedRecords: any[]) => {
      const resources = getResourceDetailsForRemoval(selectedRecords);
      setAddSignatureToResourceModal({
        show: true,
        data: { resources, reviewId },
      });
    };

    const closeAddSignatureModal = (shouldRefreshGrid: boolean) => {
      setAddSignatureToResourceModal({ show: false, data: {} });

      if (shouldRefreshGrid) {
        refreshData(true, false, false);
      }
    };

    const toolbarClickHandler = useCallback(
      (toolClicked: string) => {
        const selectedRecords = dataGrid.current?.dataView?.getAllSelectedItems() || [];

        if (toolClicked === "add_file") {
          addFileInReview();
        }

        if (toolClicked === "update_file" && selectedRecords.length >= 1) {
          const fileVersionIds = selectedRecords.map((record: any) => record.fileVersionId);
          updateFileVersionInReview(fileVersionIds);
        }

        if (toolClicked === "remove_file" && selectedRecords.length >= 1) {
          removeFileFromReview(selectedRecords);
        }

        if (toolClicked === "file_activity") {
          openFileActivity();
        }
        if (toolClicked === "excel_export_reviews" && selectedRecords.length >= 1 && allowSendTransmittals) {
          const count = processRecordsForTransmittals();
          if (count > 0) setOpenCreateTransmittalModal(true);
        }
        if (toolClicked === "download_reviews_files" && selectedRecords.length >= 1) {
          const fileVersionIds = selectedRecords.map((record: any) => record.fileVersionId);
          downLoadReviewFiles(fileVersionIds);
        }
        if (toolClicked === "bulk_transition" && selectedRecords.length > 1 && allowBulkTransition) {
          executeBulkTransition(selectedRecords);
        }

        if (toolClicked === "add_signature" && selectedRecords.length >= 1 && allowAddSignature) {
          addSignatureToResource(selectedRecords);
        }

        if ((toolClicked === "file_properties" || toolClicked === "properties") && selectedRecords.length === 1) {
          openFileProperties(selectedRecords[0]);
        }
      },

      [allowSendTransmittals, allowBulkTransition, allowAddSignature, reviewId],
    );

    const selectionEvents = () => {
      if (dataGrid && dataGrid.current) {
        const selectedRecords = dataGrid.current?.dataView?.getAllSelectedItems() || [];

        const removeBtnState = selectedRecords.length >= 1;
        const updateBtnState = removeBtnState;
        const bulkTransitionState = allowBulkTransition && selectedRecords.length > 1;
        const addSignatureState = allowAddSignature && selectedRecords.length >= 1;
        const downloadButton = selectedRecords.length >= 1;
        const addTransmittalExcelState = allowSendTransmittals && selectedRecords.length >= 1;

        setPropertiesBtnDisabled(selectedRecords.length !== 1);

        allowFileRemoval && dataGrid.current.toolbarModule?.enableItems(["remove_file"], removeBtnState);
        allowFileUpdate && dataGrid.current.toolbarModule?.enableItems(["update_file"], updateBtnState);
        dataGrid.current.toolbarModule?.enableItems(["bulk_transition"], bulkTransitionState);
        dataGrid.current.toolbarModule?.enableItems(["add_signature"], addSignatureState);
        dataGrid.current.toolbarModule?.enableItems(["excel_export_reviews"], addTransmittalExcelState);
        dataGrid.current.toolbarModule?.enableItems(["download_reviews_files"], downloadButton);

        if (selectedRecords.length !== 1) {
          closeFileProperties();
        }
      }
    };

    const dataBound = (ready: boolean) => {
      setIsLoadingComplete(ready);
    };

    const handleToastNotification = (response: any) => {
      if (response.data.status) {
        dispatch(
          showToastNotification({
            content: t("The selected files have been added to the review"),
            type: TOAST_TYPE_SUCCESS,
          }) as any,
        );
        refreshData(true, true, true);
        return;
      }

      const content = response.data.errorMessage || t("The file(s) could not be added to the review");
      dispatch(showToastNotification({ content, type: TOAST_TYPE_ERROR }) as any);
    };

    const resourceSelectionCallback = async (listOfFiles: any) => {
      const resources = Object.values(listOfFiles);
      const resourcesMap = getResourceDetails(resources);

      if (!resourcesMap.length) {
        dispatch(showToastNotification({ content: t("Please add atleast one file"), type: TOAST_TYPE_ERROR }) as any);
        return;
      }
      const hasChecklist = reviewData?.workflow?.checklists;

      if (hasChecklist) {
        const normalized = {
          resources: resourcesMap,
          workflow: {
            checklists: reviewData.workflow.checklists,
            reviewLevels: reviewData.workflow.reviewLevels,
          },
          checklistAssignments: [],
        };

        setChecklistFlowData(normalized);
        setAddFileModal((prev) => ({ ...prev, show: true, stage: 2, data: { resources: resourcesMap } }));
        return;
      }

      setIsLoadingAddFiles(true);
      const response = await addResourcesToReview({
        resources: resourcesMap,
        reviewId,
      });
      setIsLoadingAddFiles(false);
      closeAddFileModal();
      handleToastNotification(response);
    };

    const removeFilesFromReview = async () => {
      const { resources } = removeFileModal;
      setIsLoadingRemoveFiles(true);
      const response = await removeResourcesFromReview({ reviewId, resources });
      setIsLoadingRemoveFiles(false);
      closeRemoveFileModal();

      if (response.data.status) {
        dispatch(
          showToastNotification({
            content: t("The selected files have been removed from the review"),
            type: TOAST_TYPE_SUCCESS,
          }) as any,
        );
        refreshData(true, true, true);
        return;
      }

      const content = response.data.errorMessage
        ? untranslated(response.data.errorMessage)
        : t("The file(s) could not be removed from the review");
      dispatch(showToastNotification({ content, type: TOAST_TYPE_ERROR }) as any);
    };

    const updateFilesInReviewHandler = async () => {
      const { fileVersionIds } = updateFileConfirmModal;
      setIsLoadingFileUpdate(true);

      const response = await updateFilesInReview({ reviewId, fileVersionIds });
      setIsLoadingFileUpdate(false);
      closeUpdateFileModal();

      if (response.data.status) {
        dispatch(
          showToastNotification({
            content: t("The selected files have been updated to their latest version"),
            type: TOAST_TYPE_SUCCESS,
          }) as any,
        );
        refreshData(true, true, true);
        return;
      }

      const content = response.data.errorMessage
        ? untranslated(response.data.errorMessage)
        : t("The file(s) could not be updated in the review");
      dispatch(showToastNotification({ content, type: TOAST_TYPE_ERROR }) as any);
    };

    const getFormTemplate = useCallback(async () => {
      const response = await axiosWrapper.post<GetFormTemplateResponse>(`${getBackendUrl()}/portal/getFormTemplate`, {
        resourceType: formCategories.projects,
        projectId,
      });

      if (response.data.status && response.data.data) {
        const processedData = processProjectCustomFieldData(response.data.data);
        setProjectCustomField(processedData);
      }
    }, [projectId]);

    useEffect(() => {
      getFormTemplate();
    }, [getFormTemplate]);

    useEffect(() => {
      reviewDataHelperRef.current = reviewData;
    }, [reviewData]);

    useEffect(() => {
      if (!isLoadingComplete) return;
      const slickGrid = dataGrid.current?.slickGrid;
      if (!slickGrid) return;
      slickGrid.invalidate();
      slickGrid.render();
    }, [reviewData?.reviewStatus, reviewData?.workflow?.checklists, dataGrid, isLoadingComplete]);

    useEffect(() => {
      if (dataGrid && dataGrid.current && isLoadingComplete) {
        const selectedRecords = dataGrid.current?.dataView?.getAllSelectedItems() || [];

        const removeBtnState = !!(allowFileRemoval && selectedRecords.length >= 1);
        const updateBtnState = !!(allowFileUpdate && selectedRecords.length >= 1);
        const addBtnState = !!allowFileAddition;
        const bulkTransitionState = !!(selectedRecords.length > 1 && allowBulkTransition);
        const addSignatureState = !!(selectedRecords.length >= 1 && allowAddSignature);
        const addTransmittalExcelState = !!(selectedRecords.length >= 1 && allowSendTransmittals);
        const downloadButton = !!(selectedRecords.length >= 1);

        dataGrid.current.toolbarModule?.enableItems(["bulk_transition"], bulkTransitionState);
        dataGrid.current.toolbarModule?.enableItems(["add_signature"], addSignatureState);
        dataGrid.current.toolbarModule?.enableItems(["excel_export_reviews"], addTransmittalExcelState);
        dataGrid.current.toolbarModule?.enableItems(["remove_file"], removeBtnState);
        dataGrid.current.toolbarModule?.enableItems(["update_file"], updateBtnState);
        dataGrid.current.toolbarModule?.enableItems(["download_reviews_files"], downloadButton);
        dataGrid.current.toolbarModule?.enableItems(["add_file"], addBtnState);
      }
    }, [
      isLoadingComplete,
      showProperties,
      allowFileAddition,
      allowFileUpdate,
      allowFileRemoval,
      allowBulkTransition,
      allowAddSignature,
      allowSendTransmittals,
      dataGrid,
    ]);

    const downloadTransmittalDetailsInExcels = async () => {
      const response = await getReviewData({ _id: reviewId });
      const result = processReviewDataForAttachedFiles(response.data.result, userDetails);
      const transmittalData = await axiosWrapper.post<GetTransmittalDataByIdResponse>(
        `${getBackendUrl()}/transmittals/getTransmittalDataById`,
        {
          transmittalId: result.latestAttachedToTransmittal.transmittalId,
        },
      );
      const data = processDrawingNumbersAndDocDate(transmittalData.data.metadata?.files || []);
      dispatch(setTransmittalDataForReviews(null) as any);
      doExcelExportActivity({
        projectData,
        filesDetails: data,
        indexAtProjectLevel: result.latestAttachedToTransmittal.transmittalIndexAtProjectLevel,
        subject: transmittalData.data.data?.subject || "",
        projectCustomField: projectCustomField.data,
      });
    };

    useEffect(() => {
      if (
        transmittalDataForReviews &&
        projectCustomField.status &&
        ["fichtnerindia.app.cube.ms", "techture.staging.cube.ms"].includes(portalData.frontendUrl)
      ) {
        downloadTransmittalDetailsInExcels();
      }
    }, [transmittalDataForReviews, projectCustomField.status]);

    const openFileInViewerFormatter = (row: number, cell: number, value: any, columnDef: any, dataContext: any) => {
      const container = document.createElement("div");
      container.className = "cursor-pointer";
      container.dataset.fileversionid = dataContext.fileVersionId;
      container.innerHTML = `<img src="${OpenFileInViewerIcon}" alt="${t("Open in Viewer")}" />`;
      container.onclick = openFileInViewer as any;
      return container;
    };

    const fileTypeFormatter = (row: number, cell: number, value: any, columnDef: any, dataContext: any) => {
      return dataContext.details?.fileType || "";
    };

    const _dropdownItemTemplate = useCallback((args: any) => {
      const style = getStatusBtnStyle(args.category);
      return (
        <div className="py-2 px-3">
          <span style={style} className="rounded py-1 px-4 text-sm text-white">
            {args.name}
          </span>
        </div>
      );
    }, []);

    const openReferencedFilesAttachedFromData = (rowData: any) => {
      setOpenAttachmentModal({
        show: true,
        fileVersionId: rowData.fileVersionId,
        attachments: rowData.referencedFiles,
      });
    };

    const FileStatusDropdown = ({ args }: { args: any }) => {
      const status = args.statuses.slice(-1)[0];
      const [localStatusOptions, setLocalStatusOptions] = useState<any[]>(statusOptionsCache[args.fileVersionId] || []);

      useEffect(() => {
        if (statusOptionsCache[args.fileVersionId]) {
          setLocalStatusOptions(statusOptionsCache[args.fileVersionId] ?? []);
          return;
        }
        let cancelled = false;
        const fetchOptions = async () => {
          const resource = fileStatusHelper(args);
          const options: any = await fetchStatusOptionsForFile(args.fileVersionId, resource);
          if (!cancelled) {
            setLocalStatusOptions(Array.isArray(options) ? options : []);
          }
        };
        fetchOptions();
        return () => {
          cancelled = true;
        };
      }, [args.fileVersionId]);

      const selectedOption = localStatusOptions.find((opt: any) => opt._id === status._id) || null;
      const isDraft = reviewDataHelperRef.current.reviewStatus === "Draft";
      const isStatusDisabled = isDraft || localStatusOptions.length === 0;

      return (
        <div className="flex flex-row items-center gap-4">
          <AutoComplete
            options={localStatusOptions}
            valueField="_id"
            width={"12.5rem"}
            openOnFocus={!isStatusDisabled}
            disabled={isStatusDisabled}
            getOptionLabel={(option: any) => option?.name || ""}
            value={selectedOption}
            onChange={(_event: any, newValue: any) => {
              if (newValue) {
                fileStatusChanged(newValue, status, args.fileVersionId, args.resourceType);
              }
            }}
            renderOption={(props: any, option: any) => (
              <li {...props} style={{ ...props.style, paddingInlineStart: "0.25rem", paddingInlineEnd: "0.25rem" }}>
                <div className="py-2 px-1">
                  <span
                    style={getStatusBtnStyle(option.category)}
                    className="whitespace-nowrap rounded py-1 px-4 text-sm text-white"
                  >
                    {option.name}
                  </span>
                </div>
              </li>
            )}
            renderInput={(params: any) => {
              if (selectedOption) {
                params.InputProps = {
                  ...params.InputProps,
                  startAdornment: (
                    <ToolTipComponent position="top" content={selectedOption.name}>
                      <span
                        style={getStatusBtnStyle(selectedOption.category)}
                        className="truncate rounded px-3 py-0.5 text-sm text-white max-w-full cursor-pointer"
                        onClick={(e) => {
                          const input = e.currentTarget.closest(".MuiAutocomplete-root")?.querySelector("input");
                          if (input) {
                            input.focus();
                            input.dispatchEvent(new MouseEvent("mousedown", { bubbles: true }));
                          }
                        }}
                      >
                        {selectedOption.name}
                      </span>
                    </ToolTipComponent>
                  ),
                };
                params.inputProps = {
                  ...params.inputProps,
                  style: {
                    ...params.inputProps?.style,
                    opacity: 0,
                    width: 0,
                    minWidth: 0,
                    padding: 0,
                    position: "absolute",
                  },
                };
              }
              return <TextFieldComponent {...params} />;
            }}
            onKeyDown={(e) => e.stopPropagation()}
            slotProps={{ listbox: { sx: { maxHeight: "15.625rem", overflowY: "auto", minWidth: "max-content" } } }}
            sx={{ flexGrow: 1, cursor: "pointer", "& .MuiInputBase-root": { cursor: "pointer" } }}
          />
        </div>
      );
    };

    const fileStatusFormatter = (row: number, cell: number, value: any, columnDef: any, dataContext: any) => {
      const container = document.createElement("div");
      const checklistAssignments = dataContext.checklistAssignments || [];

      const root = portalCreateRoot(container);
      flushSync(() => {
        root.render(
          <div className="flex flex-row items-center gap-4" onClick={(e) => e.stopPropagation()}>
            <FileStatusDropdown args={dataContext} />
            {dataContext.statuses?.length > 1 || dataContext.signatures?.length ? (
              <DetailsIcon
                size="24"
                color="#192048"
                onClick={() => openStatusHistoryFromData(dataContext)}
                className="cursor-pointer"
              />
            ) : (
              <ToolTipComponent position="left" showTipPointer content={t("There is no status history for this file")}>
                <span className="flex items-center cursor-not-allowed opacity-50">
                  <DetailsIcon size="20" color="#192048" onClick={undefined} />
                </span>
              </ToolTipComponent>
            )}
            <Box
              onClick={() => openReferencedFilesAttachedFromData(dataContext)}
              className="w-14 h-6 cursor-pointer items-center justify-center flex rounded-2xl border border-primary_text"
            >
              <IconComponent name="smallAttachmentIcon" width="1rem" height="1rem" />{" "}
              {_.get(dataContext, "referencedFiles", []).length > 0 ? _.size(dataContext.referencedFiles) : ""}{" "}
            </Box>

            {reviewDataHelperRef.current.workflow?.checklists &&
              reviewDataHelperRef.current.reviewStatus != "Draft" && (
                <Box
                  onClick={() => openChecklistModalFromData(dataContext)}
                  className="w-14 h-6 cursor-pointer items-center justify-center flex gap-1 rounded-2xl border border-primary_text"
                >
                  <IconComponent name="checklists" width="1.125rem" height="0.875rem" />
                  {checklistAssignments.length > 0 && <span>{checklistAssignments.length}</span>}
                </Box>
              )}
          </div>,
        );
      });
      return container;
    };

    const getFileSizeOptionIndex = (size: number): number => {
      const index = size > (fileSizeOptions[1]?.divideValue ?? 0) ? 1 : 0;
      return index;
    };

    const fileSizeFormatter = (row: number, cell: number, value: any, columnDef: any, dataContext: any) => {
      const size = dataContext.details?.size || 0;
      const fileSizeIndex = getFileSizeOptionIndex(size);
      const fileSizeOption = fileSizeOptions[fileSizeIndex];
      const sizeValue = parseFloat((size / (fileSizeOption?.divideValue ?? 1)).toString()).toFixed(2);
      return `${sizeValue} ${fileSizeOption?.name ?? ""}`;
    };

    const areIssuesPresentFormatter = (row: number, cell: number, value: any, columnDef: any, dataContext: any) => {
      if (dataContext.details?.countOfIssues) {
        const container = document.createElement("div");
        portalCreateRoot(container).render(<IconComponent name="issues" width="1.5rem" height="1.5rem" />);
        return container;
      }
      return "";
    };

    const fileNameFormatter = (row: number, cell: number, value: any, columnDef: any, dataContext: any) => {
      const name = dataContext.details?.name || "";
      const container = document.createElement("div");
      container.className = "truncate";
      portalCreateRoot(container).render(
        <ToolTipComponent position="bottom" content={name}>
          <span className="truncate">{name}</span>
        </ToolTipComponent>,
      );
      return container;
    };

    const fileVersionFormatter = (row: number, cell: number, value: any, columnDef: any, dataContext: any) => {
      const { versionNumber, isLatestVersion } = dataContext.details || {};
      const container = document.createElement("div");
      container.className = "flex flex-row gap-1 items-center";

      if (!isLatestVersion) {
        portalCreateRoot(container).render(
          <div className="flex flex-row gap-1 items-center">
            {`V${versionNumber}`}
            <ToolTipComponent
              showTipPointer
              position="bottom"
              content={t(
                "You are currently working on an older version of this file. There is a newer version available",
              )}
            >
              <span className="flex items-center">
                <DetailsIcon size="24" color="#ff0000" className={undefined} onClick={undefined} />
              </span>
            </ToolTipComponent>
          </div>,
        );
      } else {
        container.textContent = `V${versionNumber}`;
      }
      return container;
    };

    const fileActivityHeader = () => (
      <div className="w-full flex flex-row justify-between items-center rounded-md">
        <Text className="font-semibold text-lg">{t("File History")}</Text>
      </div>
    );

    const fileActivityContent = () => (
      <div className=" h-600">
        <ResourceActivityInReview reviewId={reviewId} spaceId={spaceId} projectId={projectId} />
      </div>
    );

    const updateFileModalHeader = () => (
      <Text className="w-full text-2xl font-bold rounded-t-2">{t("Update Version")}</Text>
    );

    const updateFileModalContent = () => (
      <div className="flex flex-col gap-4 ps-8 pt-4 pe-8">
        <Text className="whitespace-normal break-words">
          {t("Are you sure you want to update the selected file(s) to their latest version ?")}
        </Text>
        <Text className="whitespace-normal break-words">
          <Text className="font-semibold">{t("Note")}</Text>
          {":"}
          <Text className="whitespace-normal break-words">
            {t(
              "A notification will be sent to the previous reviewers stating that their has been an update in the files of this review",
            )}
          </Text>
        </Text>
      </div>
    );

    const updateFileModalFooter = () => (
      <div className="flex flex-row gap-4 items-center justify-start">
        <ButtonComponent
          onClick={updateFilesInReviewHandler}
          buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
          loading={isLoadingFileUpdate}
        >
          <Text>{t("Confirm")}</Text>
        </ButtonComponent>
        <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeUpdateFileModal}>
          <Text>{t("Cancel")}</Text>
        </ButtonComponent>
      </div>
    );

    const removeFileModalHeader = () => (
      <Text className="w-full text-2xl font-bold rounded-t-2">{t("Remove File(s)")}</Text>
    );

    const removeFileModalContent = () => (
      <Text noWrap>
        {t("Do you want to remove the selected resources and their associated issue(s) from the review?")}
      </Text>
    );

    const removeFileModalFooter = () => (
      <div className="flex flex-row gap-4 items-center justify-start">
        <ButtonComponent
          onClick={removeFilesFromReview}
          buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
          loading={isLoadingRemoveFiles}
        >
          <Text>{t("Confirm")}</Text>
        </ButtonComponent>
        <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeRemoveFileModal}>
          <Text>{t("Cancel")}</Text>
        </ButtonComponent>
      </div>
    );

    const columnDefinitions = useMemo(
      () => [
        {
          id: "fileVersionId",
          field: "fileVersionId",
          name: "",
          width: 0,
          excludeFromColumnPicker: true,
          minWidth: 0,
          maxWidth: 0,
          initiallyHidden: true,
          disableFiltering: true,
          disableSorting: true,
          disableGrouping: true,
        },
        {
          id: "openInViewer",
          field: "",
          name: "",
          width: 50,
          minWidth: 50,
          excludeFromColumnPicker: true,
          maxWidth: 50,
          formatter: openFileInViewerFormatter,
          disableFiltering: true,
          disableSorting: true,
          disableGrouping: true,
        },
        {
          id: "issuesPresent",
          field: "",
          name: "",
          width: 50,
          minWidth: 50,
          maxWidth: 50,
          excludeFromColumnPicker: true,
          formatter: areIssuesPresentFormatter,
          disableFiltering: true,
          disableSorting: true,
          disableGrouping: true,
        },
        {
          id: "resourceType",
          field: "resourceType",
          name: "",
          width: 0,
          minWidth: 0,
          excludeFromColumnPicker: true,
          maxWidth: 0,
          initiallyHidden: true,
          disableFiltering: true,
          disableSorting: true,
          disableGrouping: true,
        },
        {
          id: "name",
          field: "details.name",
          name: t("Name"),
          width: 200,
          minWidth: 200,
          formatter: fileNameFormatter,
          filterType: "Text",
        },
        {
          id: "fileType",
          field: "fileType",
          name: t("Type"),
          width: 80,
          minWidth: 80,
          formatter: fileTypeFormatter,
          filterType: "Text",
          _valueGetter: (row: any) => row.details?.fileType || "",
        },
        {
          id: "versionNumber",
          field: "versionNumber",
          name: t("Version"),
          width: 100,
          minWidth: 80,
          formatter: fileVersionFormatter,
          filterType: "Number",
          _valueGetter: (row: any) => (row.details?.versionNumber ? `V${row.details.versionNumber}` : ""),
        },
        {
          id: "size",
          field: "size",
          name: t("Size"),
          width: 100,
          minWidth: 80,
          formatter: fileSizeFormatter,
          disableFiltering: true,
          _valueGetter: (row: any) => {
            const size = row.details?.size || 0;
            const fileSizeIndex = getFileSizeOptionIndex(size);
            const fileSizeOption = fileSizeOptions[fileSizeIndex];
            const sizeValue = parseFloat((size / (fileSizeOption?.divideValue ?? 1)).toString()).toFixed(2);
            return `${sizeValue} ${fileSizeOption?.name ?? ""}`;
          },
        },
        {
          id: "status",
          field: "status",
          name: t("Status"),
          width: 550,
          minWidth: 450,
          formatter: fileStatusFormatter,
          filterType: "Text",
          _valueGetter: (row: any) => row.statuses?.slice(-1)[0]?.name || "",
        },
      ],

      [],
    );

    const getDataGrid = () => (
      <div
        className={
          isLoadingComplete
            ? "h-full w-full overflow-auto flex flex-col"
            : "h-full w-full overflow-auto flex flex-col invisible"
        }
      >
        <SlickGrid1
          ref={dataGrid}
          remoteDataSource={getResourcesInReviewUrl}
          query={filesQuery}
          toolbar={toolbar}
          toolbarClickHandler={toolbarClickHandler}
          columnDefinitions={columnDefinitions as any}
          onSelectedRowIdsChanged={selectionEvents}
          setGridReady={dataBound}
          rowHeight={50}
          gridHeight="100%"
          enableColumnChooser
          infiniteScroll
          enableFilteringOption
          enableSortingOption
          enableGroupingOption
          excelExport
          hideNoDataIllustration
          propertiesPanel={showProperties}
          propertiesDisabled={propertiesBtnDisabled}
          gridOptions={{ forceFitColumns: true }}
        />
      </div>
    );

    return (
      <div className="flex flex-row w-full h-full overflow-auto">
        {getDataGrid()}
        {fileProperties.show && showProperties && (
          <FilePropertiesInReviews {...fileProperties.data} closeProperties={closeFileProperties} />
        )}
        {signatureModal.show && <ChangeFileStatusModal {...(signatureModal as any)} closeModal={closeSignatureModal} />}
        {bulkTransitionModal.show && (
          <ChangeFileStatusModal {...(bulkTransitionModal.data as any)} closeModal={closeBulkTransitionModal} />
        )}
        {addSignatureToResourceModal.show && (
          <AddSignatureToResource closeModal={closeAddSignatureModal} {...(addSignatureToResourceModal.data as any)} />
        )}
        {addFileModal.show && addFileModal.stage === 1 && (
          <FileManagerAsPopup
            projectId={projectId}
            workspaceId={spaceId}
            attachSelectedBtnName={t("Attach Files")}
            id="fileManagerAsPopup"
            handleFileSelectedButtonClick={resourceSelectionCallback}
            handleFileSelectedCancelClick={closeAddFileModal}
            hideIssues
            hideTasks
            hideSchedules
            hideEstimates
            hideReviews
            hideMergeFiles
            hideContracts
            hideClashTests
            openThisSpaceByDefault
            isLoadingAddFiles={isLoadingAddFiles}
            setIsLoadingAddFiles={setIsLoadingAddFiles}
            disableFiles={
              dataGrid?.current ? dataGrid.current.currentViewData.map((record: any) => record.fileVersionId) : []
            }
            minimumFiles={1}
          />
        )}
        {addFileModal.show && addFileModal.stage === 2 && reviewData.workflow.checklists && addFileModal.data && (
          <ChecklistAssignmentModal
            reviewData={checklistFlowData}
            setReviewData={setChecklistFlowData}
            onNext={handleChecklistAssignment}
            onBack={backToFileSelection}
          />
        )}
        {removeFileModal.show && (
          <ModalStateDialogComponent
            isVisible
            allowModalPadding={false}
            width="31.25rem"
            headerTitle={removeFileModalHeader()}
            modelContent={removeFileModalContent()}
            footerContent={removeFileModalFooter()}
            onCancel={closeRemoveFileModal}
          />
        )}
        {updateFileConfirmModal.show && updateFileConfirmModal.fileVersionIds.length && (
          <ModalStateDialogComponent
            isVisible
            allowModalPadding={false}
            width="31.25rem"
            headerTitle={updateFileModalHeader()}
            modelContent={updateFileModalContent()}
            footerContent={updateFileModalFooter()}
            onCancel={closeUpdateFileModal}
          />
        )}

        {fileActivityModal.show && (
          <ModalStateDialogComponent
            isVisible
            allowModalPadding={false}
            width="62.5rem"
            headerTitle={fileActivityHeader()}
            modelContent={fileActivityContent()}
            onCancel={closeFileActivityModal}
          />
        )}
        {statusHistoryModal.show && (
          <ResourceStatusHistoryInReview
            statuses={(statusHistoryModal.statuses || []) as any}
            closeModal={closeStatusHistory}
            showSignatureHistory
            signatures={(statusHistoryModal.signatures || []) as any}
          />
        )}
        {openAttachmentModal.show && (
          <Attachments
            closeAttachmentModal={closeAttachmentModal}
            attachments={openAttachmentModal.attachments || []}
            fileVersionId={openAttachmentModal.fileVersionId || ""}
            reviewId={reviewId}
          />
        )}

        {checklistModal.show && (
          <ChecklistModal
            fileVersionId={checklistModal.fileVersionId || ""}
            closeModal={closeChecklistModal}
            reviewId={reviewId}
            refreshData={refreshData}
            projectId={projectId}
          />
        )}
        <CreateTransmittal
          isOpen={openCreateTransmittalModal}
          onClose={() => setOpenCreateTransmittalModal(false)}
          projectId={projectId}
          selectedSpaceId={spaceId}
          selectedReferences={processedTransmittalRecords}
          reviewId={reviewId}
        />
      </div>
    );
  },
);

FilesInReview.displayName = "FilesInReview";
export default FilesInReview;
